import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [RouterLink],
  template: `
    <footer class="layout-footer site-footer" aria-label="Pie de página">
      <nav class="site-footer__nav" aria-label="Enlaces del pie">
        <a routerLink="/home">Inicio</a>
        <a routerLink="/empleados">Profesionales</a>
        <a routerLink="/contact">Contacto</a>
      </nav>
      <p class="site-footer__credit">
        Web creada por
        <a href="https://systemctl.es" target="_blank" rel="noopener noreferrer" class="site-footer__brand">SystemCTL</a>
      </p>
      @if (!haySesion()) {
        <a [routerLink]="['/auth/login']" class="site-footer__login">Acceso profesional</a>
      }
    </footer>
  `
})
export class AppFooter {
  haySesion(): boolean {
    const token = localStorage.getItem('token');
    return !!token && token !== 'undefined' && token !== 'null';
  }
}
